<template>
    <div>
        <div>
            <b-row class="pt-4 pb-4 px-4">
                <b-col class="position-container col-12">
                    <b-card class="card-content">
                        <div>
                            <p class="card-description">
                                {{ $t('strategy.onepage.noAttribute.description') }}
                            </p>
                            <b-button
                                @click="$emit('createAttribute', name)"
                                class="card-link"
                                variant="link"
                                v-if="isCurrentUserVisible"
                            >
                                <h3>
                                    {{ $t('strategy.onepage.noAttribute.createAttribute') }}
                                </h3>
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoAttribute',
    props: {
        name: String,
    },
    computed: {
        isCurrentUserVisible() {
            const types = ['local_administrator', 'administrator', 'god']
            return types.includes(this.$store.getters.getCurrentUser.role.name)
        },
    },
}
</script>

<style lang="sass" scoped>
.position-container
    display: flex
    align-items: center
    margin-bottom: 2rem
    .icon-content
        color: #009ADA
        font-size: 2.7rem
        border-color: #009ADA !important
        margin-right: 1rem
    .card-content
        margin-bottom: 0 !important
        width: 100%
        text-align: center
        .card-description
            margin: 0
            font-weight: bold
            color: #bec0c0
            font-size: 1.2rem
        .card-link
            font-weight: bold
</style>
